document.addEventListener('DOMContentLoaded', () => {
    const submitDelayAfterChange = 1000 // ms

    const libraryEl = document.querySelector('[data-library]')
    if (!libraryEl) return

    // libraryEl.querySelectorAll('.library-product-group-button').forEach((badgeEl) => {
    //     badgeEl.addEventListener('click', (event) => event.stopPropagation())
    // })

    libraryEl.querySelectorAll('.library-document-toggle').forEach((toggleEl) => {
        const panelEl = document.getElementById(toggleEl.getAttribute('aria-controls'))
        if (!panelEl) return

        const transitionTime = parseInt(panelEl.dataset.transitionHeightTime)
        panelEl.style.transition = `height ${transitionTime}ms ease`

        toggleEl.addEventListener('click', (event) => {
            if (toggleEl.closest('.library-public-section') && !event.target.closest('.library-document-title, .library-document-description, .library-document-reference, .library-document-symbol')) return

            const itemEl = toggleEl.closest('.library-document')
            const willOpen = toggleEl.getAttribute('aria-expanded') !== 'true'
            toggleEl.setAttribute('aria-expanded', willOpen ? 'true' : 'false')
            itemEl.classList.toggle('is-open', willOpen)
            const panelHeight = calcPanelHeight(panelEl) + 'px'
            if (willOpen) {
                panelEl.hidden = false;
                panelEl.style.height = '0px';
                setTimeout(() => {
                    panelEl.style.height = panelHeight
                }, 1)
            } else {
                panelEl.classList.toggle('hidden', true)
                panelEl.style.height = panelHeight;
                setTimeout(() => {
                    panelEl.style.height = '0px'
                }, 1)
            }
            setTimeout(() => {
                panelEl.hidden = !willOpen;
                panelEl.style.height = 'auto';
            }, 200)
        })
    })

    /* Handle search control (text input) */
    const textInputEl = libraryEl.querySelector('.library-search-control input[type="text"]')
    const textSubmitEl = libraryEl.querySelector('.library-search-control .text-submit')
    const textClearEl = libraryEl.querySelector('.library-search-control .text-clear')
    if (!textInputEl || !textSubmitEl || !textClearEl) return
    textInputEl.addEventListener('input', () => {
        if (textInputEl.value) {
            textSubmitEl.classList.remove('display-none')
            textClearEl.classList.add('display-none')
        } else {
            textSubmitEl.classList.add('display-none')
        }
    })
    textClearEl.addEventListener('click', () => {
        textInputEl.value = ''
        textClearEl.classList.add('display-none')
        textInputEl.closest('form').submit()
    })

    /* Handle library tag checkboxes and submit 1 second after last change on them */
    const tagCheckboxes = libraryEl.querySelectorAll('.library-tags input[type="checkbox"]')
    const tagIdsInput = libraryEl.querySelector('input[name="tag_ids"]')
    let tagChangeTimeout = null
    tagCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
            const selectedValues = Array.from(tagCheckboxes)
                .filter((cb) => cb.checked)
                .map((cb) => cb.value)
            tagIdsInput.value = selectedValues.join(',')
            if (tagChangeTimeout) clearTimeout(tagChangeTimeout)
            tagChangeTimeout = setTimeout(() => {
                tagIdsInput.closest('form').submit()
            }, submitDelayAfterChange)
        })
    })

    const calcPanelHeight = (panelEl) => {
        const display = panelEl.style.display
        const hidden = panelEl.hidden
        panelEl.style.display = 'block'
        const height = panelEl.offsetHeight
        panelEl.style.display = display
        panelEl.hidden = hidden
        return height
    }
})
